<template>
    <transition name="el-fade-in">
        <div class="all" v-show="show">
            <div class="title">{{ name || "Reminder" }}</div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/reminder-list' }"
                    >reminder list</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{
                    name || "change reminder"
                }}</el-breadcrumb-item>
            </el-breadcrumb>
            <page-editer
                :modelData.sync="data"
                :render="renderData"
                :handlerSave="Save"
                :handlerDelete="Delete"
                :handleLoad="Loaded"
            ></page-editer>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            show: false,
            renderData: [
                {
                    key: "Title",
                    type: "input",
                    modelName: "title",
                    must: true,
                    maxlength: "50",
                },
                {
                    key: "Content",
                    type: "textarea",
                    modelName: "content",
                    maxlength: "255",
                    must: true,
                },
            ],
            data: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        Save() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            this.$request("/manage/reminder/save", uploadData, (res) => {
                if (res.data.code === 200) {
                    this.$message({
                        message: "save success",
                        type: "success",
                    });
                    this.$router.push("/reminder-list");
                }
            });
        },
        Delete() {
            this.$confirm("Confirm delete？", "", { type: "warning" }).then(
                () => {
                    this.$request(
                        `/manage/reminder/del/${this.$route.query.id}`,
                        {},
                        (res) => {
                            if (res.data.code === 200) {
                                this.$message({
                                    message: "delete success",
                                    type: "success",
                                });
                                this.$router.go(-1);
                            }
                        }
                    );
                }
            );
        },
        Loaded() {
            this.show = true;
            if (this.$route.query.id && this.$route.query.id != "add") {
                this.$request(
                    `/manage/reminder/detail/${this.$route.query.id}`,
                    {},
                    (res) => {
                        let data = res.data.data;
                        this.renderData.some((item) => {
                            if (item.type === "selects" && data[item.modelName]) {
                                data[item.modelName] = data[item.modelName].split(",");
                            }
                        });
                        this.data = data;
                    },
                    "get",
                    true
                );
            }
            // 获取reminder的使用音频 导入进 render
            this.$request("/manage/adoText/listExcUse", {}, (res) => {
                if (res.data.code === 200) {
                    res.data.data.some((item) => {
                        item.value = item.id;
                        item.label = item.audioText;
                    });
                    this.renderData.some((item) => {
                        if (item.modelName === "audioTextId") {
                            item.options = res.data.data;
                        }
                    });
                }
            });
        },
    },
};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 40px;
    text-align: left;
    font-size: 13px;
    margin-top: 30px;
}
.title {
    font-size: 24px;
    line-height: 50px;
}
.el-breadcrumb {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
}
/* .kuai-con .el-input >>> input
{
    font-size: 13px;
    height: 27px;
} */
</style>